import { foundationToastStyles } from '@genesislcap/foundation-ui';
import { neutralLayer1, neutralLayer3 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { chartPinkWebRGBA, primaryBlueWebRGBA, secondaryTealWebRGBA, secondaryOrangeWebRGBA, warningYellowWebRGBA, } from '../_config/styles/colors';
// See https://www.fast.design/docs/fast-element/leveraging-css/, https://www.fast.design/docs/design-systems/fast-frame
export const zeroToastStyles = css `
  ${foundationToastStyles}
  .toast {
    border: calc(var(--stroke-width) * 1px) solid ${neutralLayer3};
    background-color: ${neutralLayer1};
  }

  .toast::after {
    background-color: ${primaryBlueWebRGBA(1)};
  }

  :host([notify='warning']) .toast::after {
    background-color: ${chartPinkWebRGBA(1)};
  }

  :host([notify='success']) .toast::after {
    background-color: ${secondaryTealWebRGBA(1)};
  }

  :host([notify='critical']) .toast::after {
    background-color: ${warningYellowWebRGBA(1)};
  }

  :host([notify='serious']) .toast::after {
    background-color: ${secondaryOrangeWebRGBA(1)};
  }
`;
